<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{
                    $t("language.new")
                  }}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="grid.search"
                    append-icon="search"
                    :label="$t('language.search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>{{ $t("language.company") }}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-flex xs12 sm6 md4>
                              <ValidationProvider
                                :name="$t('language.dealer')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="vModel.dealerid"
                                  :items="dealerList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.dealer')"
                                  :error-messages="errors[0]"
                                  :clearable="true"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.subdomain')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.subdomain"
                                :label="$t('language.subdomain')"
                                :error-messages="errors[0]"
                                :disabled="isEdit"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.noofbranch')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.noofbranch"
                                :label="$t('language.noofbranch')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.noofstaff')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.noofstaff"
                                :label="$t('language.noofstaff')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.defaultlanguage')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="vModel.defaultlanguage"
                                :items="$store.getters.locales"
                                item-text="title"
                                item-value="locale"
                                :label="$t('language.defaultlanguage')"
                                :error-messages="errors[0]"
                                :clearable="true"
                              ></v-autocomplete>
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.datetype')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="vModel.datetype"
                                :items="$store.getters.dateTypes"
                                item-text="title"
                                item-value="id"
                                :label="$t('language.datetype')"
                                :error-messages="errors[0]"
                                :clearable="true"
                              ></v-autocomplete>
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.minattendancegap')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.minattendancegap"
                                :label="$t('language.minattendancegap')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enablerecommender"
                              :label="$t('language.enablerecommender')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.appendidtoname"
                              :label="$t('language.appendidtoname')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enableot"
                              :label="$t('language.enableot')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enablebreakinbreakout"
                              :label="$t('language.enablebreakinbreakout')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enableattendanceapplication"
                              :label="
                                $t('language.enableattendanceapplication')
                              "
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enablemobileapp"
                              :label="$t('language.enablemobileapp')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.enableadms"
                              :label="$t('language.enableadms')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.gracetimeinmin')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.gracetimeinmin"
                                :label="$t('language.gracetimeinmin')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.gracetimeoutmin')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.gracetimeoutmin"
                                :label="$t('language.gracetimeoutmin')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-menu
                              v-model="menu.softwareinstallationdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="vModel.softwareinstallationdate"
                                  :label="
                                    $t('language.softwareinstallationdate')
                                  "
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="vModel.softwareinstallationdate"
                                @input="menu.softwareinstallationdate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-menu
                              v-model="menu.softwareexpirationdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="vModel.softwareexpirationdate"
                                  :label="$t('language.softwareexpirationdate')"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="vModel.softwareexpirationdate"
                                @input="menu.softwareexpirationdate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey darken-1" text @click="closedialog">{{
                        $t("language.cancel")
                      }}</v-btn>
                      <v-btn color="blue darken-1" text type="submit">{{
                        $t("language.save")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-dialog
              v-model="deleteLogDialog"
              max-width="300px"
              min-height="300px"
            >
              <ValidationObserver ref="formdeletelog" v-slot="{ passes }">
                <v-form @submit.prevent="passes(deletelog)">
                  <v-card>
                    <v-card-title>
                      Delete Attendance Log
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-menu
                              v-model="menu.fromdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="deleteLogVModel.fromdate"
                                  label="From Date"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="deleteLogVModel.fromdate"
                                @input="menu.fromdate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="grey darken-1"
                        text
                        @click="deleteLogDialog = false"
                        >{{ $t("language.cancel") }}</v-btn
                      >
                      <v-btn color="blue darken-1" text type="submit">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.subdomain>
                <span>{{ $t("language.subdomain") }}</span>
              </template>
              <template v-slot:header.noofbranch>
                <span>{{ $t("language.noofbranch") }}</span>
              </template>
              <template v-slot:header.noofstaff>
                <span>{{ $t("language.noofstaff") }}</span>
              </template>
              <template v-slot:header.softwareinstallationdate>
                <span>{{ $t("language.softwareinstallationdate") }}</span>
              </template>
              <template v-slot:header.softwareexpirationdate>
                <span>{{ $t("language.softwareexpirationdate") }}</span>
              </template>
              <template v-slot:header.codecopy>
                <span>{{ $t("language.code") }}</span>
              </template>
              <template v-slot:header.action>
                <span>{{ $t("language.actions") }}</span>
              </template>
              <template v-slot:item.codecopy="{ item }">
                <v-btn small class="mr-2" @click="copyToClipboard(item.code)"
                  >Copy</v-btn
                >
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.subdomain)"
                  >edit</v-icon
                >
                <v-icon small class="mr-2" @click="deleteItem(item.subdomain)"
                  >delete</v-icon
                >
                <v-icon small @click="showdeletelog(item.subdomain)" v-if="$store.getters.role=='SUPERADMIN'"
                  >alarmoff</v-icon
                >
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Base from "../../shared/Base.vue";
import axios from "axios";
export default {
  name: "companyview",
  extends: Base,
  data() {
    return {
      menu: {
        softwareinstallationdate: false,
        softwareexpirationdate: false,
        fromdate: false,
      },
      dealerList: [],
      deleteLogVModel: { fromdate: null, subdomain: null },
      deleteLogDialog: null,
    };
  },
  created() {
    this.grid.headers = [
      { value: "subdomain" },
      { value: "noofbranch" },
      { value: "noofstaff" },
      { value: "softwareinstallationdate" },
      { value: "softwareexpirationdate" },
      { value: "codecopy", sortable: false },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      dealerid: null,
      subdomain: null,
      noofbranch: null,
      noofstaff: null,
      defaultlanguage: null,
      datetype: null,
      minattendancegap: null,
      enablerecommender: false,
      appendidtoname: false,
      enableot: false,
      enablebreakinbreakout: false,
      enableattendanceapplication: false,
      enablemobileapp: false,
      enableadms: false,
      softwareinstallationdate: null,
      softwareexpirationdate: null,
      gracetimeinmin: null,
      gracetimeoutmin:null
    };
    this.url = "admin/companies";
  },
  beforeRouteEnter(to, from, next) {
    axios.get("admin/list/dealer").then((response) => {
      next((p) => {
        p.dealerList = response.data;
      });
    });
  },
  methods: {
    copyToClipboard(text) {
      const el = document.createElement("textarea"); // Create a <textarea> element
      el.value = text; // Set its value to the string that you want copied
      el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
      el.style.position = "absolute";
      el.style.left = "-9999px"; // Move outside the screen to make it invisible
      document.body.appendChild(el); // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false; // Mark as false to know no selection existed before
      el.select(); // Select the <textarea> content
      document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el); // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        document.getSelection().addRange(selected); // Restore the original selection
      }
    },
    deletelog() {
      if (this.loading) return;
      this.loading = true;
      axios
        .post(
          "admin/companies/delete/log",
          this.deleteLogVModel
        )
        .then(
          () => {
            this.$store.dispatch(
              "showSuccessMessage",
              "Log deleted successfully"
            );
            this.deleteLogDialog = false;
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    },
    showdeletelog(subdomain) {
      this.deleteLogVModel.subdomain = subdomain;
      this.deleteLogDialog = true;
    },
  },
};
</script>
